<template>
  <vx-card v-if="editableOpeningHours" no-shadow>
    <h2 class="mb-6">Opening Hours</h2>

    <div v-if="utcOpeningHours" class="vx-row mb-6">
      <div class="vx-col w-full opening-hours-row">
        <span class="day">Monday</span>
        <vs-switch v-model="utcOpeningHours.isOpenMonday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr
          v-if="utcOpeningHours.isOpenMonday"
          @on-change="onMondayOpenChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.mondayOpen"
          class="ml-6"
          placeholder="Open from..."
        />
        <flat-pickr
          v-if="utcOpeningHours.isOpenMonday"
          @on-change="onMondayCloseChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.mondayClose"
          class="ml-3"
          placeholder="Closed from..."
        />
      </div>

      <div class="vx-col w-full opening-hours-row mt-3">
        <span class="day">Tuesday</span>
        <vs-switch v-model="utcOpeningHours.isOpenTuesday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr
          v-if="utcOpeningHours.isOpenTuesday"
          @on-change="onTuesdayOpenChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.tuesdayOpen"
          class="ml-6"
          placeholder="Open from..."
        />
        <flat-pickr
          v-if="utcOpeningHours.isOpenTuesday"
          @on-change="onTuesdayCloseChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.tuesdayClose"
          class="ml-3"
          placeholder="Closed from..."
        />
      </div>

      <div class="vx-col w-full opening-hours-row mt-3">
        <span class="day">Wednesday</span>
        <vs-switch v-model="utcOpeningHours.isOpenWednesday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr
          v-if="utcOpeningHours.isOpenWednesday"
          @on-change="onWednesdayOpenChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.wednesdayOpen"
          class="ml-6"
          placeholder="Open from..."
        />
        <flat-pickr
          v-if="utcOpeningHours.isOpenWednesday"
          @on-change="onWednesdayCloseChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.wednesdayClose"
          class="ml-3"
          placeholder="Closed from..."
        />
      </div>

      <div class="vx-col w-full opening-hours-row mt-3">
        <span class="day">Thursday</span>
        <vs-switch v-model="utcOpeningHours.isOpenThursday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr
          v-if="utcOpeningHours.isOpenThursday"
          @on-change="onThursdayOpenChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.thursdayOpen"
          class="ml-6"
          placeholder="Open from..."
        />
        <flat-pickr
          v-if="utcOpeningHours.isOpenThursday"
          @on-change="onThursdayCloseChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.thursdayClose"
          class="ml-3"
          placeholder="Closed from..."
        />
      </div>

      <div class="vx-col w-full opening-hours-row mt-3">
        <span class="day">Friday</span>
        <vs-switch v-model="utcOpeningHours.isOpenFriday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr
          v-if="utcOpeningHours.isOpenFriday"
          @on-change="onFridayOpenChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.fridayOpen"
          class="ml-6"
          placeholder="Open from..."
        />
        <flat-pickr
          v-if="utcOpeningHours.isOpenFriday"
          @on-change="onFridayCloseChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.fridayClose"
          class="ml-3"
          placeholder="Closed from..."
        />
      </div>

      <div class="vx-col w-full opening-hours-row mt-3">
        <span class="day">Saturday</span>
        <vs-switch v-model="utcOpeningHours.isOpenSaturday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr
          v-if="utcOpeningHours.isOpenSaturday"
          @on-change="onSaturdayOpenChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.saturdayOpen"
          class="ml-6"
          placeholder="Open from..."
        />
        <flat-pickr
          v-if="utcOpeningHours.isOpenSaturday"
          @on-change="onSaturdayCloseChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.saturdayClose"
          class="ml-3"
          placeholder="Closed from..."
        />
      </div>

      <div class="vx-col w-full opening-hours-row mt-3">
        <span class="day">Sunday</span>
        <vs-switch v-model="utcOpeningHours.isOpenSunday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr
          v-if="utcOpeningHours.isOpenSunday"
          @on-change="onSundayOpenChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.sundayOpen"
          class="ml-6"
          placeholder="Open from..."
        />
        <flat-pickr
          v-if="utcOpeningHours.isOpenSunday"
          @on-change="onSundayCloseChangeEvent"
          :config="configdateTimePicker"
          v-model="editableOpeningHours.sundayClose"
          class="ml-3"
          placeholder="Closed from..."
        />
      </div>
    </div>

    <div class="flex flex-wrap items-center justify-end">
      <vs-button
        v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.venueinfo.edit')"
        @click="saveOpeningHours"
        id="save-button"
        class="ml-auto mt-2"
        >Save Opening Hours</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { mapGetters } from "vuex";

export default {
  components: {
    flatPickr,
  },
  data() {
    return {
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
        //dateFormat: 'H:i',
        defaultHour: 0,
        defaultMinute: 0,
        defaultSecond: 0,
      },
      editableOpeningHours: null,
      utcOpeningHours: null,
    };
  },
  computed: {
    ...mapGetters({
      openingHours: "venues/openingHours",
    }),
  },
  methods: {
    formatUtcOpeningHours() {
      if (this.openingHours.mondayOpen.startsWith("0001")) {
        this.openingHours.mondayOpen = this.getMidnight();
      }
      if (this.openingHours.mondayClose.startsWith("0001")) {
        this.openingHours.mondayClose = this.getMidnight();
      }

      if (this.openingHours.tuesdayOpen.startsWith("0001")) {
        this.openingHours.tuesdayOpen = this.getMidnight();
      }
      if (this.openingHours.tuesdayClose.startsWith("0001")) {
        this.openingHours.tuesdayClose = this.getMidnight();
      }

      if (this.openingHours.wednesdayOpen.startsWith("0001")) {
        this.openingHours.wednesdayOpen = this.getMidnight();
      }
      if (this.openingHours.wednesdayClose.startsWith("0001")) {
        this.openingHours.wednesdayClose = this.getMidnight();
      }

      if (this.openingHours.thursdayOpen.startsWith("0001")) {
        this.openingHours.thursdayOpen = this.getMidnight();
      }
      if (this.openingHours.thursdayClose.startsWith("0001")) {
        this.openingHours.thursdayClose = this.getMidnight();
      }

      if (this.openingHours.fridayOpen.startsWith("0001")) {
        this.openingHours.fridayOpen = this.getMidnight();
      }
      if (this.openingHours.fridayClose.startsWith("0001")) {
        this.openingHours.fridayClose = this.getMidnight();
      }

      if (this.openingHours.saturdayOpen.startsWith("0001")) {
        this.openingHours.saturdayOpen = this.getMidnight();
      }
      if (this.openingHours.saturdayClose.startsWith("0001")) {
        this.openingHours.saturdayClose = this.getMidnight();
      }

      if (this.openingHours.sundayOpen.startsWith("0001")) {
        this.openingHours.sundayOpen = this.getMidnight();
      }
      if (this.openingHours.sundayClose.startsWith("0001")) {
        this.openingHours.sundayClose = this.getMidnight();
      }

      this.utcOpeningHours = Object.assign({}, this.openingHours);
    },
    onMondayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.mondayOpen = selectedDates[0].toISOString();
      }
    },
    onMondayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.mondayClose = selectedDates[0].toISOString();
      }
    },
    onTuesdayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.tuesdayOpen = selectedDates[0].toISOString();
      }
    },
    onTuesdayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.tuesdayClose = selectedDates[0].toISOString();
      }
    },
    onWednesdayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.wednesdayOpen = selectedDates[0].toISOString();
      }
    },
    onWednesdayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.wednesdayClose = selectedDates[0].toISOString();
      }
    },
    onThursdayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.thursdayOpen = selectedDates[0].toISOString();
      }
    },
    onThursdayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.thursdayClose = selectedDates[0].toISOString();
      }
    },
    onFridayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.fridayOpen = selectedDates[0].toISOString();
      }
    },
    onFridayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.fridayClose = selectedDates[0].toISOString();
      }
    },
    onSaturdayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.saturdayOpen = selectedDates[0].toISOString();
      }
    },
    onSaturdayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.saturdayClose = selectedDates[0].toISOString();
      }
    },
    onSundayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.sundayOpen = selectedDates[0].toISOString();
      }
    },
    onSundayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) {
        this.utcOpeningHours.sundayClose = selectedDates[0].toISOString();
      }
    },

    getMidnight() {
      let date = new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);

      return date;
    },

    async saveOpeningHours() {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#save-button",
        scale: 0.45,
      });

      this.$store
        .dispatch("venues/updateOpeningHours", this.utcOpeningHours)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Opening hours saved",
          });
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not save opening hours: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close("#save-button > .con-vs-loading");
        });
    },
  },
  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("venues/getOpeningHours");
    this.editableOpeningHours = this.openingHours;
    this.formatUtcOpeningHours();
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
.day {
  font-weight: 500;
  width: 100px;
}

.opening-hours-row {
  display: flex;
  align-items: center;
  min-height: 40px;
}
</style>